import {
  Directive,
  EventEmitter,
  HostListener,
  Output,
  OnInit,
  OnDestroy,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appSmartTap]',
  standalone: true
})
export class SmartTapDirective implements OnInit, OnDestroy {
  @Output() appSmartTap = new EventEmitter<Event>();

  private isTouchDevice = false;
  private clickHandled = false;
  private clickTimeout: any;

  // ✅ Injectez PLATFORM_ID pour détecter si on est dans le navigateur
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    // ✅ Vérifiez qu'on est dans le navigateur avant d'accéder à window
    if (isPlatformBrowser(this.platformId)) {
      this.isTouchDevice = 'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        (navigator as any).msMaxTouchPoints > 0;
    }
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    if (this.isTouchDevice) {
      event.preventDefault();
      event.stopPropagation();
      this.clickHandled = true;
      this.appSmartTap.emit(event);

      // Reset après 500ms pour éviter les problèmes
      clearTimeout(this.clickTimeout);
      this.clickTimeout = setTimeout(() => {
        this.clickHandled = false;
      }, 500);
    }
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    // Sur desktop OU si touchstart n'a pas été déclenché
    if (!this.clickHandled) {
      event.preventDefault();
      event.stopPropagation();
      this.appSmartTap.emit(event);
    }
  }

  ngOnDestroy() {
    if (this.clickTimeout) {
      clearTimeout(this.clickTimeout);
    }
  }
}
